import React, { FC } from 'react';
import { connect } from 'react-redux';
import { toggleShowOfficeServices } from '@store/actions';
import {
  officeServicesCatalogModalSelector,
  OfficeServicesCatalogModalProps,
} from './structuredSelector';
import CatalogModal from '../CatalogModal';

interface OfficeCatalogModalProps extends OfficeServicesCatalogModalProps {
  toggleShowOfficeServices: (payload?: any) => any;
}

const OfficeCatalogModal: FC<OfficeCatalogModalProps> = ({
  visible,
  toggleShowOfficeServices,
}) => <CatalogModal visible={visible} onClose={toggleShowOfficeServices} />;

const mapDispatchToProps = (dispatch) => ({
  toggleShowOfficeServices: (payload) =>
    dispatch(toggleShowOfficeServices(payload)),
});

export default connect(
  officeServicesCatalogModalSelector,
  mapDispatchToProps
)(OfficeCatalogModal);
